export { default } from "./TenantManagementEdit";
